
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Benefits from "./components/Benefits";
import Process from "./components/Process";
import Testimonials from "./components/Testimonials";
import ClientDashboard from "./components/ClientDashboard";
import Contact from "./components/Contact";
import useSEO from "../../hooks/useSEO";

const Home = () => {
  // SEO dinámico para la home
  useSEO({
    title: "SEOgenia - Automatización SEO con IA Generativa | Optimización Web Avanzada",
    description: "Automatización SEO con IA Generativa. Optimización técnica avanzada, Schema Markup, PWA, Core Web Vitals, Voice Search y SEO para agentes IA. Resultados medibles y crecimiento sostenible para tu sitio web.",
    keywords: "automatización seo, seo con ia, optimización web, seo técnico, schema markup, core web vitals, voice search, pwa, seo agentes ia",
    canonical: "https://seogenia.es/"
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <Benefits />
      <Process />
      <ClientDashboard />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
